import { Action, ActionContext, ActionTree } from "vuex";
import { RootState } from "@/store/RootState";
import {
  PlayerAction,
  PlayerMutation,
  PlayerState
} from "@/components/player/types";

const updatePause = (context: ActionContext<PlayerState, RootState>): void => {
  context.commit(PlayerMutation.SetPause);
};

export const actions: ActionTree<PlayerState, RootState> &
  Record<PlayerAction, Action<PlayerState, RootState>> = {
  [PlayerAction.UpdatePause]: updatePause
};
